export enum GroupType {
  UNSORTED = 'unsorted',
  EMPLOYEE = 'employee',
  EXTERNAL = 'external',
  IGNORE = 'ignore',
}

export const DATE_FORMAT = 'YYYY-MM-DD';

export {};
